<template>
  <div class="request-voice-over uk-margin-large-bottom">
    <PageHeader title="Voice Over Aanvragen"
                :image="require('@/assets/images/jason-de-ridder.jpg')">
      Fijn dat je overweegt om mij te kiezen. Ik heb er alle vertrouwen in dat we jouw
      productie kunnen verrijken. Vul onderstaand formulier in en dan neem ik zo snel mogelijk
      contact met je op. Als je nog twijfels heb of ik wel echt de juiste ben voor jouw product
      Klik dan het vinkje &lsquo;Ik wil een gratis stemdemo&rsquo; aan. Ik neem dan een demo voor
      je op zodat je nog beter kan bepalen of mijn stem is wat je zoekt.
    </PageHeader>

    <div class="tabbed-form uk-container">
      <ul class="
          tabs
          uk-flex
          uk-flex-center
          uk-flex-stretch
          uk-child-width-1-3
          uk-grid-collapse
          uk-text-center
        " uk-grid ref="switcher">
        <li :class="{completed: completedStep1, active: isActive(1)}" data-step="0">
          <a href="javascript:void(0);"
             data-step="0"
             class="uk-link uk-text-normal"
          >
            Stap 1<span class="uk-visible@m">: Productie en stem</span>
          </a>
        </li>
        <li :class="{completed: completedStep2, active: isActive(2)}" data-step="1">
          <a href="javascript:void(0);"
             data-step="1"
             class="uk-link uk-text-normal"
          >
            Stap 2<span class="uk-visible@m">: Gegevens en overzicht</span>
          </a>
        </li>
        <li :class="{completed: completedStep3, active: isActive(3)}" data-step="2">
          <a href="javascript:void(0);"
             data-step="2"
             class="uk-link uk-text-normal"
          >
            Stap 3<span class="uk-visible@m">: Bevestiging</span>
          </a>
        </li>
      </ul>

      <ul class="uk-switcher">
        <li data-step="0" class="uk-animation-fade">
          <div>
            <div class="background-darker price-calculator-small">
              <div class="uk-padding-large">
                <h2 class="no-border">
                  Type productie
                  <small>Wat ga je maken?</small>
                </h2>
                <ButtonSelector :buttons="buttons" @change="changeProductionType"/>

                <div class="uk-margin-medium-top uk-animation-fade"
                     v-if="questions.productionType === 'commercial'">
                  <hr>
                  <h3>Voor welk medium?</h3>
                  <div class="uk-flex-center uk-child-width-1-3 uk-grid uk-grid-stack" uk-grid>
                    <BigRadioButton label="Online"
                                    :value="questions.commercial.medium"
                                    index="online"
                                    name="commercial-medium"
                                    @change="questions.commercial.medium = $event"/>
                    <BigRadioButton label="Radio"
                                    index="radio"
                                    :value="questions.commercial.medium"
                                    name="commercial-medium"
                                    @change="questions.commercial.medium = $event"/>
                    <BigRadioButton label="Televisie" name="commercial-medium"
                                    index="tv"
                                    :value="questions.commercial.medium"
                                    @change="questions.commercial.medium = $event"/>
                  </div>

                  <div v-if="(
                  this.questions.commercial.medium === 'tv'
                  || this.questions.commercial.medium === 'radio')"
                       class="uk-margin-medium-top uk-animation-fade">
                    <hr>
                    <h3>Welk uitzendgebied?</h3>
                    <div class="uk-flex-center uk-child-width-1-3 uk-grid uk-grid-stack" uk-grid>
                      <BigRadioButton label="Lokaal" name="commercial-reach"
                                      :value="questions.commercial.reach"
                                      index="local"
                                      @change="questions.commercial.reach = $event"/>
                      <BigRadioButton label="Regionaal" name="commercial-reach"
                                      :value="questions.commercial.reach"
                                      index="regional"
                                      @change="questions.commercial.reach = $event"/>
                      <BigRadioButton label="Landelijk" name="commercial-reach"
                                      :value="questions.commercial.reach"
                                      index="national"
                                      @change="questions.commercial.reach = $event"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="background-darker price-calculator-small uk-margin-large-top">
              <div class="uk-padding-large">
                <h2 class="no-border">
                  Tone of voice
                  <small>Maximaal 3 combinaties</small>
                </h2>
                <ToneOfVoiceSelector @change="changeToneOfVoice"/>
              </div>
            </div>
          </div>

          <div class="background-darker price-calculator-small uk-margin-large-top">
            <div class="uk-padding-large">
              <h2 class="no-border">
                Lengte
                <small v-if="questions.productionType === 'commercial'">
                  Hoe lang gaat de reclame duren?
                </small>
                <small v-else>Hoeveel woorden heeft je script?</small>
              </h2>

              <RangeSlider
                :min="sliderValues.min"
                :max="sliderValues.max"
                :defaultValue="sliderValues.default"
                ref="slider"
                :step="sliderValues.step"
                :minLabel="sliderValues.minLabel"
                :maxLabel="sliderValues.maxLabel"
                :outputSuffix="sliderValues.suffix"
                @change="changeLength"
              />
            </div>
          </div>

          <div class="price-calculator-small uk-margin-medium-top">
            <div>
              <h3>
                Plaats je script<br>
                <small class="uk-text-normal uk-text-muted">
                  <label for="script-area">Heb je al een script?</label>
                </small>
              </h3>

              <textarea
                id="script-area"
                cols="50"
                rows="8"
                class="uk-textarea"
                v-model="questions.script"
                placeholder="Plaats hier je script"
              />
              <p class="uk-text-muted uk-margin-remove-top">
                Aantal woorden in de tekst: {{ amountOfWordsInScript }}
              </p>
            </div>
          </div>

          <div class="price-calculator-small uk-margin-medium-top summary-blocks">
            <div class="uk-flex-center uk-grid uk-grid-stack" uk-grid>
              <div class="uk-text-center uk-text-left@s uk-width-1-2 uk-width-1-6@s">
                <h4 v-if="questions.productionType === 'commercial'">Aantal seconden</h4>
                <h4 v-else>Aantal woorden</h4>
                <span class="price">
                  {{
                    questions.productionType === 'commercial'
                      ? questions.amountOfSeconds
                      : questions.amountOfWords
                  }}
                </span>
              </div>

              <div class="uk-text-center uk-text-left@s uk-width-1-2 uk-width-1-6@s">
                <h4>Prijsindicatie (excl. BTW)</h4>
                <span class="price">
                  {{ totalPrice }}
                </span>
              </div>

              <div class="uk-width-1-1 uk-width-1-3@s uk-text-center">
                <label class="uk-margin-medium-top">
                  <br class="uk-visible@s">
                  <input type="checkbox" class="uk-checkbox" v-model="questions.freeDemo">
                  Ik wil graag eerst een stemdemo ontvangen
                </label>
              </div>

              <div class="uk-width-1-1 uk-width-1-3@s">
                <button type="button"
                        class="uk-button uk-button-default uk-button-large uk-width-1-1@xs"
                        :disabled="!completedStep1 === true"
                        @click="moveToTab(2);"
                >
                  Verder
                </button>
              </div>
            </div>
          </div>
        </li>

        <li data-step="1" class="uk-animation-fade">
          <div v-if="this.errorSending" id="errorMessageSending">
            <p class="uk-text-danger uk-text-bold uk-text-center uk-animation-shake">
              Er ging iets mis met verzenden. Probeer het nogmaals
              of stuur een e-mail naar <a href="mailto:jason@voiceoveracteur.nl">
              jason@voiceoveracteur.nl</a>.
            </p>
          </div>
          <div class="uk-grid" uk-grid>
            <div class="uk-overlay-primary uk-position-cover uk-position-fixed uk-animation-fade"
                 v-if="this.inRequest"></div>
            <div class="uk-width-1-1 uk-width-3-4@m">
              <div class="uk-form-stacked">
                <div class="uk-grid uk-child-width-1-1" uk-grid>
                  <div>
                    <label class="uk-form-label" for="request_voice_over-company">
                      Bedrijfsnaam of organisatie
                    </label>
                    <div class="uk-form-controls">
                      <input type="text" class="uk-input"
                             @keyup="validate('company')"
                             :class="{
                                'uk-form-success': validation.company === true,
                                'uk-form-danger': validation.company === false,
                             }"
                             v-model="questions.requester.company"
                             id="request_voice_over-company"/>
                      <label class="uk-display-block uk-padding-small">
                        <input type="checkbox" class="uk-checkbox"
                               v-model="questions.requester.nonProfit"
                        />
                        Mijn organisatie is een geregistreerd goed doel (ANBI).
                      </label>
                    </div>
                  </div>
                  <div class="uk-grid uk-child-width-1-2" uk-grid>
                    <div class="uk-width-1-2">
                      <label class="uk-form-label" for="firstName">
                        Voornaam
                      </label>
                      <div class="uk-form-controls">
                        <input type="text" class="uk-input"
                               @keyup="validate('firstName')"
                               :class="{
                                'uk-form-success': validation.firstName === true,
                                'uk-form-danger': validation.firstName === false,
                             }"
                               v-model="questions.requester.firstName"
                               id="firstName"/>
                      </div>
                    </div>
                    <div class="uk-width-1-2">
                      <label class="uk-form-label" for="lastName">
                        Achternaam
                      </label>
                      <div class="uk-form-controls">
                        <input type="text" class="uk-input"
                               @keyup="validate('lastName')"
                               :class="{
                                'uk-form-success': validation.lastName === true,
                                'uk-form-danger': validation.lastName === false,
                             }"
                               v-model="questions.requester.lastName"
                               id="lastName"/>
                      </div>
                    </div>
                  </div>
                  <div>
                    <label class="uk-form-label" for="email">
                      E-mailadres
                    </label>
                    <div class="uk-form-controls">
                      <input type="email" class="uk-input"
                             @keyup="validate('email')"
                             :class="{
                                'uk-form-success': validation.email === true,
                                'uk-form-danger': validation.email === false,
                             }"
                             v-model="questions.requester.email"
                             id="email"/>
                    </div>
                  </div>
                  <div>
                    <label class="uk-form-label" for="phone">
                      Telefoonnummer
                    </label>
                    <div class="uk-form-controls">
                      <input type="tel" class="uk-input"
                             @keyup="validate('phone')"
                             :class="{
                                'uk-form-success': validation.phone === true,
                                'uk-form-danger': validation.phone === false,
                             }"
                             v-model="questions.requester.phone"
                             id="phone"/>
                    </div>
                  </div>
                  <div>
                    <label class="uk-form-label" for="remarks">
                      Opmerkingen en/of aanvullingen
                    </label>
                    <div class="uk-form-controls">
                      <textarea class="uk-textarea"
                                id="remarks"
                                v-model="questions.requester.remarks"
                                cols="30" rows="6"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="uk-width-1-1 uk-width-1-4@m">
              <div class="background-darker uk-padding-small uk-height-1-1
              uk-flex uk-flex-column uk-flex-between">
                <h2 class="uk-text-left uk-text-condensed small-header">
                  Overzicht
                  <button type="button"
                          @click="moveToTab(1, true)"
                          class="uk-button
                          uk-button-secondary
                          uk-button-small
                          uk-text-condensed
                          uk-float-right
                          padding-tiny
                    ">
                    Wijzigen
                  </button>
                </h2>
                <div class="uk-flex uk-flex-column uk-flex-between uk-height-1-1">
                  <div class="request-summary-block">
                    <p>
                      <label>Type productie</label>
                      <span>{{ questions.selectedButton }}</span>
                    </p>
                  </div>
                  <div class="request-summary-block">
                    <p>
                      <label>Tone of Voice(s)</label>
                      <span>{{ questions.toneOfVoice.join(', ') }}</span>
                    </p>
                  </div>
                  <div class="request-summary-block">
                    <p>
                      <label>Levering</label>
                      <span>Binnen 24 uur</span> (waar mogelijk)
                    </p>
                  </div>
                  <div class="request-summary-block">
                    <p>
                      <label>Lengte</label>
                      <span>
                      {{
                          questions.productionType === 'commercial'
                            ? questions.amountOfSeconds
                            : questions.amountOfWords
                        }}
                    </span>
                      ({{ questions.productionType === 'commercial' ? 'seconden' : 'woorden' }})
                    </p>
                  </div>
                  <div class="request-summary-block">
                    <p>
                      <label>Prijsindicatie (ex. BTW)</label>
                      <span>{{ totalPrice }}</span>
                    </p>
                  </div>
                  <div class="request-summary-block" v-if="questions.freeDemo">
                    <p>
                      <label>Inclusief</label>
                      <span>Gratis stemdemo</span>
                    </p>
                  </div>
                  <div>
                    <label>
                      <input type="checkbox" class="uk-checkbox"
                             :class="{
                                'uk-form-success': validation.agree === true,
                                'uk-form-danger': validation.agree === false,
                             }"
                             v-model="questions.requester.agree">
                      Ja, ik ga akkoord met de algemene voorwaarden
                    </label>
                  </div>
                  <div class="uk-margin-small-top uk-margin-remove-top@m">
                    <button type="button" class="uk-button uk-button-large
                    uk-button-default uk-width-1-1"
                            @click="submitForm"
                            :disabled="this.formValid === false || this.inRequest">
                      Aanvragen
                    </button>
                    <small class="uk-text-muted uk-display-block uk-margin-small-top">
                      De aanvraag wordt pas definitief na ons contact en ondertekening
                      van de opdrachtovereenkomst.
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>

        <li data-step="2" class="uk-animation-fade">
          <div class="uk-margin-top-medium">
            <h1>Bedankt voor je aanvraag!</h1>
            <p class="uk-text-center">
              Je ontvangt binnen enkele ogenblikken automatisch een bevestigingsmail
              <br class="uk-visible@s">
              en ik neem zo spoedig mogelijk contact persoonlijk met je op.
            </p>
            <p class="uk-text-center">
              Mocht je nog iets vergeten zijn, of wil je je aanvraag aanvullen,
              <br class="uk-visible@s">
              mail mij dan direct op <a href="mailto:jason@voiceoveracteur.nl">
              jason@voiceoveracteur.nl</a>.
            </p>
            <p class="uk-text-center">
              Leuk, ik heb zin om voor je aan de slag te gaan!
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue';
import ButtonSelector from '@/components/ButtonSelector.vue';
import UIkit from 'uikit';
import buttons from '@/assets/content/buttons';
import ToneOfVoiceSelector from '@/components/ToneOfVoiceSelector.vue';
import BigRadioButton from '@/components/BigRadioButton.vue';
import RangeSlider from '@/components/RangeSlider.vue';
import priceCalculator from '@/assets/content/priceCalculator';
import fetch from 'node-fetch';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const config = require('@/../config.js');

export default {
  name: 'RequestVoiceOver.vue',
  components: {
    RangeSlider,
    ToneOfVoiceSelector,
    ButtonSelector,
    PageHeader,
    BigRadioButton,
  },
  data() {
    return {
      send: false,
      errorSending: false,
      inRequest: false,
      questions: {
        productionType: (this.$route.query.productionType || 'video').trim(),
        amountOfWords: Number(this.$route.query.amountOfWords || 100),
        amountOfSeconds: Number(this.$route.query.amountOfSeconds || 30),
        selectedButton: (this.$route.query.selectedButton || 'bedrijfsfilm').trim(),
        toneOfVoice: [],
        price: this.totalPrice,
        script: '',
        commercial: {
          reach: undefined,
          medium: undefined,
        },
        freeDemo: false,
        requester: {
          company: undefined,
          nonProfit: false,
          firstName: undefined,
          lastName: undefined,
          email: undefined,
          phone: undefined,
          remarks: undefined,
          agree: false,
        },
      },
      completedStep3: false,
      activeStep: 1,
      validation: {
        company: undefined,
        nonProfit: undefined,
        firstName: undefined,
        lastName: undefined,
        email: undefined,
        phone: undefined,
        remarks: undefined,
        agree: undefined,
      },
    };
  },
  computed: {
    buttons() {
      return buttons(this.questions.selectedButton);
    },
    amountOfWordsInScript() {
      if (this.questions.script) {
        return this.questions.script.match(/\S+/g).length - 1;
      }

      return 0;
    },
    completedStep1() {
      return (
        this.questions.productionType
        && (this.questions.amountOfWords || this.questions.amountOfSeconds)
        && (
          (
            this.questions.productionType === 'commercial'
            && (
              (
                (
                  this.questions.commercial.medium === 'radio'
                  || this.questions.commercial.medium === 'tv'
                )
                && this.questions.commercial.reach
              )
              || this.questions.commercial.medium === 'online')
          )
          || this.questions.productionType !== 'commercial'
        )
        && this.questions.toneOfVoice.length > 0
      );
    },
    completedStep2() {
      return (this.formValid && this.send);
    },
    formValid() {
      return (
        this.validation.firstName === true
        && this.validation.lastName === true
        && this.validation.email === true
        && (
          this.validation.company === undefined
          || this.validation.company === true
        )
        && (
          this.validation.phone === undefined
          || this.validation.phone === true
        )
        && this.questions.requester.agree === true
      );
    },
    totalPrice() {
      const result = priceCalculator(
        this.questions.productionType,
        (this.questions.productionType === 'commercial'
          ? this.questions.amountOfSeconds
          : this.questions.amountOfWords),
        this.questions.commercial.medium,
        this.questions.commercial.reach,
      );

      return (result.total ?? result).toString();
    },
    sliderValues() {
      let result;

      if (this.questions.productionType === 'commercial') {
        result = {
          min: 30,
          max: 120,
          default: 30,
          step: 15,
          minLabel: '30 seconden',
          maxLabel: '120 seconden',
          suffix: 'seconden',
        };
      } else if (this.questions.productionType === 'ivr') {
        result = {
          min: 1,
          max: 501,
          default: 20,
          step: 1,
          minLabel: '0',
          maxLabel: '500+',
          suffix: 'woorden',
        };
      } else {
        result = {
          min: 1,
          max: 5001,
          default: 100,
          step: 1,
          minLabel: '0',
          maxLabel: '5000+',
          suffix: 'woorden',
        };
      }

      return result;
    },
  },
  mounted() {
    UIkit.switcher(this.$refs.switcher);
    UIkit.util.on('.uk-switcher', 'beforeshow', (event) => {
      const targetStep = Number(event.target.dataset.step);

      if (targetStep && (
        (targetStep === 1 && !this.completedStep1)
        || (targetStep === 2 && !this.completedStep2)
      ) && this.send === false) {
        event.preventDefault();
        UIkit.switcher('.uk-switcher').show(this.activeStep - 1);
      }
    });
    UIkit.util.on('.uk-switcher', 'show', (event) => {
      if (this.send === false) {
        this.activeStep = Number(event.target.dataset.step) + 1;
      }
    });
  },
  methods: {
    isActive(tab) {
      return Number(tab) === Number(this.activeStep);
    },
    validate(field) {
      if (this.questions.requester[field] && this.questions.requester[field].length === 0) {
        this.validation[field] = undefined;
        return;
      }
      switch (field) {
        case 'firstName':
        case 'lastName':
          this.validation[field] = !(
            (typeof this.questions.requester[field] === 'undefined')
            || this.questions.requester[field].trim().length < 2
            || /[\d<>,/\\_+=*\-&^%$#@!`~?|:;[\]{}]+/.exec(this.questions.requester[field]) !== null
          );
          break;
        case 'email':
          this.validation[field] = (
            // eslint-disable-next-line no-control-regex
            /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(this.questions.requester[field])
          );
          break;
        case 'phone':
          this.validation[field] = (
            // eslint-disable-next-line no-control-regex
            /^((\+|00(\s|\s?-\s?)?)31(\s|\s?-\s?)?(\(0\)[-\s]?)?|0)[1-9]((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]$/.test(this.questions.requester[field])
            || /^((\+|00)32\s?|0)(\d\s?\d{3}|\d{2}\s?\d{2})(\s?\d{2}){2}$/.test(this.questions.requester[field])
            || /^((\+|00)32\s?|0)4(60|[789]\d)(\s?\d{2}){3}$/.test(this.questions.requester[field])
            || /^(?:(?:\(?(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?(?:\(?0\)?[\s-]?)?)|(?:\(?0))(?:(?:\d{5}\)?[\s-]?\d{4,5})|(?:\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3}))|(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4})|(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}))(?:[\s-]?(?:x|ext\.?|#)\d{3,4})?$/.test(this.questions.requester[field])
          );
          break;
        case 'agree':
          this.validation[field] = this.questions.requester[field];
          break;
        default:
          break;
      }
    },
    changeProductionType(btn) {
      this.questions.selectedButton = btn.title;
      this.questions.productionType = btn.type;

      this.$refs.slider.rangeSliderValue = (
        this.questions.productionType === 'commercial'
          ? this.questions.amountOfSeconds
          : this.questions.amountOfWords
      );
    },
    changeToneOfVoice(toneOfVoices) {
      this.questions.toneOfVoice = toneOfVoices;
    },
    changeLength(length) {
      if (this.questions.productionType === 'commercial') {
        this.questions.amountOfSeconds = Number(length);
      } else {
        this.questions.amountOfWords = Number(length);
      }
    },
    moveToTab(tab, force = false) {
      if (tab !== 3 && this.send === true) {
        return;
      }

      if (this[`completedStep${tab - 1}`] || force) {
        UIkit.switcher(this.$refs.switcher).show(tab - 1);
        this.activeStep = tab;
        UIkit.scroll(null, {
          offset: 80,
        }).scrollTo('li[data-step].active');
      }
    },
    priceCalculator,
    submitForm() {
      if (this.completedStep1 === false || this.formValid === false || this.send === true) {
        return;
      }

      this.inRequest = true;
      this.errorSending = false;

      fetch(config.requestVoiceOverURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...this.questions,
          price: this.totalPrice,
        }),
      }).then(() => {
        this.send = true;
        this.completedStep3 = true;
        this.moveToTab(3);
      })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error(error);
          this.errorSending = true;
          UIkit.scroll(null, {
            offset: 100,
          }).scrollTo('#errorMessageSending');
        })
        .finally(() => {
          this.inRequest = false;
        });
    },
  },
};
</script>
